import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Lionfish from '../../components/Lionfish/Lionfish';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardLionfish extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Lionfish/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Atlantic, Gulf of Mexico, Caribbean"
   diagnosis="Lionfish, which are native to the Indo-Pacific, were first detected along Florida coasts in the mid-1980s. The species is harming native coral reef ecosystems in the Atlantic, Gulf of Mexico, and Caribbean (NOAA)."
   prediction="Biologists suspect that lionfish populations, and their demand for native prey will continue to increase (NOAA)."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardLionfish;
